import { FeatureNewsPosts } from "./feature/index"
import { RowNewsPosts } from "./row/index"
import "./index.scss"

require.context("./static", true, /\.png|jpg|svg$/)

export { FeatureNewsPosts, RowNewsPosts }
